import { render, staticRenderFns } from "./RequestLeaveOnPastDateWarning.vue?vue&type=template&id=e5213e24"
import script from "./RequestLeaveOnPastDateWarning.vue?vue&type=script&lang=js"
export * from "./RequestLeaveOnPastDateWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports